import { ca } from '@cian/analytics';

import { getDeveloperContactsLabel } from 'shared/serp/components/header/developers_contacts';

interface ITrackOpenChatParams {
  newbuildingId: number;
  placeType: string | undefined;
}

export function trackOpenChat({ newbuildingId, placeType }: ITrackOpenChatParams) {
  ca('eventSite', {
    action: 'open',
    category: 'Message_popup',
    label: getDeveloperContactsLabel(null),
    name: 'oldevent',
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        type: placeType,
      },
    },
  });
}
